// アプリ全体で使用する定数群

export const APP = {
  NAME: 'Weekly Report',
} as const;

export const ROUTES = {
  ROOT: '/',
  WEEKLY_REPORT: '/weekly-report',
  MASTER_MANAGE: '/master-manage',
  CLASSIFICATION_MARKET: '/classification-market',
} as const;

export const ENV = {
  API_URL: process.env.REACT_APP_API_URL ?? '',
  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL ?? '',
  COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID ?? '',
  COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
  FORGOT_PASSWORD_LINK:
    process.env.REACT_APP_FORGOT_PASSWORD_LINK ??
    (process.env as any).FORGOT_PASSWORD_LINK ??
    '',
  APP_MANAGER_MAILADDRESS:
    process.env.REACT_APP_MANAGER_MAILADDRESS ??
    (process.env as any).APP_MANAGER_MAILADDRESS ??
    '',
  DEBUG: (() => {
    const val = process.env.REACT_APP_DEBUG;
    return val !== undefined && val !== null && Number(val) >= 1;
  })(),
  APPLICATION_VERSION: process.env.REACT_APP_APPLICATION_VERSION ?? '',
  // ローカル開発環境かどうか（USER_AUTH_MANAGE の権限を最優先にするかの判定に使用）
  IS_LOCAL_VERSION: process.env.REACT_APP_APPLICATION_VERSION === 'Local',
  // Hosted UI（外部IDプロバイダ連携）ログインを使うかどうか
  HOSTED_UI_ENABLED: (() => {
    const val = process.env.REACT_APP_HOSTED_UI_ENABLED;
    return val !== undefined && val !== null && Number(val) >= 1;
  })(),
  COGNITO_OAUTH_DOMAIN: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN ?? '',
  COGNITO_OAUTH_PROVIDER: process.env.REACT_APP_COGNITO_OAUTH_PROVIDER ?? '',
  COGNITO_REDIRECT_SIGNIN: process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN ?? '',
  COGNITO_REDIRECT_SIGNOUT: process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT ?? '',
  // アプリ環境移行に伴うログイン封鎖モード（1以上で有効）。有効時はログイン不可・自動ログアウト・新アプリへ誘導
  LOGIN_CLOSED: (() => {
    const val = process.env.REACT_APP_LOGIN_CLOSED;
    return val !== undefined && val !== null && Number(val) >= 1;
  })(),
  // ログイン封鎖モードで案内する新アプリのURL
  NEW_APP_URL: process.env.REACT_APP_NEW_APP_URL ?? '',
} as const;

export const API_ENDPOINTS = {
  GET_DEPARTMENTS: '/get_department',
  GET_ALL_TEAMS: '/get_all_teams',
  GET_ALL_ATTRIBUTES: '/get_all_attributes',
  GET_ATTRIBUTES: '/get_attributes',
  GET_ALL_USER_INFO: '/get_all_user_info',
  ADD_FREE_ATTRIBUTE: '/add_free_attribute',
  REFRESH_DEPARTMENTS: '/refresh_departments',
  REFRESH_DEPARTMENT_TEAMS: '/refresh_department_teams',
  REFRESH_ATTRIBUTES: '/refresh_attributes',
  GET_ALL_MANAGE_MEMBERS: '/get_all_manage_members',
  REFRESH_MANAGE_MEMBERS: '/refresh_manage_members',
  RESET_TEAM_COLUMNS: '/reset_team_columns',
  GET_ATTRIBUTE_OPTIONS_MARKET: '/get_attribute_options_market',
  ADD_ATTRIBUTE_OPTIONS_MARKET: '/add_attribute_options_market',
  UPDATE_ATTRIBUTE_OPTIONS_MARKET: '/update_attribute_options_market',
  DELETE_ATTRIBUTE_OPTIONS_MARKET: '/delete_attribute_options_market',
  IMPORT_ATTRIBUTE_OPTIONS_MARKET: '/import_attribute_options_market',
  GET_ATTRIBUTE_OPTIONS_MARKET_USING: '/get_attribute_options_market_using',
  CANCEL_ATTRIBUTE_OPTIONS_MARKET_IMPORT: '/cancel_attribute_options_market_import',
} as const;

export const DIALOG_KEYS = {
  NEW_FREE_ITEM: '新規項目',
  DIVISION: '課',
  TEAM: 'チーム',
} as const;

// 機能は維持したまま、画面上の表示だけを切り替える。
export const UI_VISIBILITY = {
  ENLIGHT_LINKAGE_SETTINGS: false,
  // true にすると、分類市場の対象属性を「週報分類」以外にも切り替えられるセレクタが復活する。
  // false の間はセレクタを非表示のまま、内部的には CLASSIFICATION_MARKET_TARGET_ATTR_NAME に一致する
  // 属性へ自動的に絞り込む（複数の選択式属性から選ぶ機能自体は削除しない）。
  CLASSIFICATION_MARKET_ATTRIBUTE_SELECTOR: false,
} as const;

// 分類市場の対象とする属性名（UI_VISIBILITY.CLASSIFICATION_MARKET_ATTRIBUTE_SELECTOR が false の間の絞り込み条件）
export const CLASSIFICATION_MARKET_TARGET_ATTR_NAME = '週報分類';
export const FIXED_ATTR_NAME_PROJECT = 'Project';
export const FIXED_ATTR_NAME_POWERTRAIN = 'パワートレイン';
export const FIXED_ATTR_NAME_SHIMUKE = '仕向け';
export const FIXED_ATTR_NAME_LOT = 'ロット';

// 分類市場テンプレート自体の「分類」選択肢。分類マスタは未実装のため、当面は 1（R&D）のみのダミー値。
export const MARKET_CATEGORY_OPTIONS = [
  { value: 1, label: 'R&D' },
] as const;

export const DATE_FORMATS = {
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm',
  DATETIME: 'YYYY-MM-DD HH:mm',
} as const;

export const ATTR_TYPE_LABEL_MAP: { [key: number]: string } = {
  1: 'フリー入力欄',
  2: 'フリー入力欄（大）',
  3: '数値（整数）',
  4: '数値（小数）',
  5: '日付（カレンダー）',
  6: '時間（HH:ii）',
  11: '選択プルダウン',
  12: '選択チェックボックス',
  13: '選択プルダウン＆フリー入力',
};

export const COLORS = {
  PRIMARY: '#1976d2',
  SUCCESS: '#2e7d32',
  WARNING: '#ed6c02',
  DANGER: '#d32f2f',
} as const;

export const STORAGE_KEYS = {
  USER_NAME: 'user_name',
} as const;
